import { Router, CanActivate } from '@angular/router';
import { Injectable } from '@angular/core';

@Injectable()
export class LoginRedirect implements CanActivate {
  constructor(private router: Router) {}

  canActivate(): boolean {
    if (sessionStorage.getItem('bbx-token')) {
      this.router.navigateByUrl('/shipment');
      return false;
    } else {
      return true;
    }
  }
}
